export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_PROFILE = "GET_PROFILE";
export const CLEAR_CURRENT_USER = "CLEAR_CURRENT_USER";
export const FORM_DATA_LOADING = "FORM_DATA_LOADING";
export const GET_FORMS_AWAITING_APPROVAL = "GET_FORMS_AWAITING_APPROVAL";
export const CLEAR_FORM_DATA = "CLEAR_FORM_DATA";
export const GENERATE_PDF_URI = "GENERATE_PDF_URI";
export const LOADING_PDF = "LOADING_PDF";
export const DONE_GENERATING_PDF = "DONE_GENERATING_PDF";
export const CLEAR_PDF_DATA = "CLEAR_PDF_DATA";
export const DOWNLOADING_PDF = "DOWNLOADING_PDF";
